export const MultipleSwitchBoxTheme = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const;

export const MultipleSwitchBoxTextWrap = {
  NO_WRAP: 'whitespace-nowrap',
  DEFAULT: '',
} as const;
